import { logEvent } from '@gelato-api-ui/core/analytics/helpers/trackEvent';

export const logStoreConnectionFailureEvent = error => {
  logEvent('storeAddNewStoreCreatedFailed', {
    error: error && error.response && error.response.error ? error.response.error : null,
  });
};
